import React, { useEffect, useState } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom'
import {
  Title,
  Common,
  Permissionkeys,
  Spinner,
  HttpService,
  API,
  DateFormat
} from '../../config/react'
const InquiryDetails = () => {
  const urlParams = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const FilterOrderNo = queryParams.get('ordernumber')
  const FilterEmail = queryParams.get('email')
  const FilterOrderFromDate = queryParams.get('orderfromdate')
  const FilterOrderToDate = queryParams.get('ordertodate')
  const FilterPage = queryParams.get('page')
  const history = useHistory()
  const [IsAuth, setIsAuth] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [InquiryDetails, setInquiryDetails] = useState([])
  const [ProductDetailsList, setProductDetailsList] = useState([])

  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Products)) {
      history.push('/')
    }
    setIsAuth(true)
    setForceUpdate(!isForceUpdate)
    document.title = Title.InquiryDetails
    GetInquiryDetails()
  }, [urlParams.id])
  const GetInquiryDetails = () => {
    const param = {
      OrderNumber: urlParams.id
    }
    HttpService.postApi(API.GetInquiryDetails, param).then((response) => {
      setInquiryDetails(response.data.result[0][0])
      setProductDetailsList(response.data.result[0][0].products)
    })
  }
  const handleBackClick = () => {
    history.push('/sales/inquiry', {
      state: {
        page: parseInt(FilterPage) === 0 ? 1 : parseInt(FilterPage),
        ordernumber: FilterOrderNo,
        ordertodate: FilterOrderToDate,
        email: FilterEmail,
        orderfromdate: FilterOrderFromDate
      }
    })
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title">{Title.InquiryDetails} </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={handleBackClick}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Inquiry & Account Information</h3>
                  </div>
                </div>

                <div className="col-md-5">
                  <div className="address-info">
                    {/* <h4>Inquiry</h4> */}
                    <h4>Inquiry {InquiryDetails.order_number}</h4>
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <td className="text-left">Inquiry Date</td>
                          {/* <td className="text-right">Jan 31, 2022, 7:07:01 PM</td>  */}
                          <td className="text-right">
                            <DateFormat value={InquiryDetails.created_at} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="address-info">
                    <h4>Account Information</h4>
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <td className="text-left">Customer Name</td>
                          <td className="text-right">
                            {InquiryDetails.firstname} {InquiryDetails.lastname}
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left">Email</td>
                          <td className="text-right">
                            <a href={'mailto:' + InquiryDetails.email}>{InquiryDetails.email}</a>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left">Phone</td>
                          <td className="text-right">{InquiryDetails.contact_number}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Address Information</h3>
                  </div>
                </div>

                <div className="col-md-5">
                  <div className="address-info">
                    <h4>
                      Billing Address {/* <a href="#" className="edit-link font-13"> Edit</a> */}
                    </h4>
                    <p>
                      {InquiryDetails.firstname} {InquiryDetails.lastname}
                      <br></br>
                      {InquiryDetails.street} {InquiryDetails.country}
                      <br></br>
                      Pin code :{InquiryDetails.postcode}
                      <br></br>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Items Inquired</h3>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table text-center">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Size</th>
                          <th>Model</th>
                          <th>SKU/Certificate</th>
                          <th>System SKU</th>
                          <th>Price</th>
                          <th>Qty</th>
                          {/* <th>Tax Amount</th> */}
                          <th>Product Discount</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ProductDetailsList?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {item.name}
                                {item.vendor !== null ? (
                                  <span>
                                    {' ( Vendor : '} <b> {item.vendor} </b>
                                    {')'}
                                  </span>
                                ) : (
                                  <></>
                                )}
                                <br />
                                {!item.is_diamond ? (
                                  <>
                                    {
                                      <>
                                        {JSON.parse(item.product_options)
                                          .filter((x) => x.show_in_storefront === 1)
                                          .map((x, index, filteredOptions) => (
                                            <span key={index}>
                                              {x.title}: <b>{x.value}</b>
                                              {index !== filteredOptions.length - 1 &&
                                                (index + 1) % 3 !== 0 &&
                                                ', '}
                                              {(index + 1) % 3 === 0 && <br />}
                                            </span>
                                          ))}
                                      </>
                                    }
                                  </>
                                ) : (
                                  ''
                                )}
                              </td>

                              <td>{item.is_diamond === 0 && item.size !== 0 ? item.size : '-'}</td>
                              <td>{item.parent_sku ? item.parent_sku : '-'}</td>
                              <td>
                                {' '}
                                {item.is_diamond !== 0
                                  ? JSON.parse(item.product_options)?.filter(
                                      (x) => x.title === 'Certificate'
                                    )[0]?.value
                                  : item.model_number}
                                <br />
                              </td>
                              <td>{item.sku}</td>
                              <td>
                                {InquiryDetails.symbol} {item.price}
                              </td>
                              <td>{item.qty}</td>

                              <td>
                                {InquiryDetails.symbol}
                                {item.discount_amount}
                              </td>
                              <td>
                                {InquiryDetails.symbol}
                                {item.final_price}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="card-header p-0 pb-2 mb-3">
                <h3 className="title font-20">Inquiry Total</h3>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="card-header p-0 mb-3">
                    <div className="col-md-12 pl-0">
                      <div className="address-info">
                        <table className="table table-striped table-borderless">
                          <tbody>
                            <tr>
                              <th className="text-left">Subtotal</th>
                              <th className="text-right">{InquiryDetails.subtotal}</th>
                            </tr>
                            <tr>
                              <td className="border-bottom text-left">Coupon Discount</td>
                              <td className="text-right border-bottom">
                                {InquiryDetails.symbol}
                                {InquiryDetails.discount_amount}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th className="text-left">Grand Total</th>
                              <th className="text-right">{InquiryDetails.formated_order_total}</th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default InquiryDetails
